<template>
  <div>
    <div class="row">
      <div class="col-md-12 col-lg-12">
        <KTCodePreview v-bind:title="'Relatório Fechamento Mês'">
          <template v-slot:preview>
            <v-row>
              <v-col cols="5">
                <v-select
                  :loading="carregandoClientes"
                  :items="clientes"
                  label="Cliente"
                  item-text="nome"
                  item-value="id"
                  v-model="filtro.clienteID"
                  clearable
                >
                  <template template v-slot:selection="{ item }">
                    <div>
                      <span>{{ ` ${item.nome}` }}</span>
                    </div>
                  </template>
                  <template v-slot:item="{ item }">
                    <div>
                      <span>{{ ` ${item.nome}` }}</span>
                    </div>
                  </template>
                </v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col align-self="start">
                <v-btn @click="gerar" color="primary" large>Gerar</v-btn>
              </v-col>
              <v-progress-linear
                v-if="loading"
                indeterminate
                color="indigo"
              ></v-progress-linear>
            </v-row>
          </template>
        </KTCodePreview>
      </div>
    </div>
    <v-alert border="left" color="secondary" v-if="loading">
      <v-progress-circular indeterminate color="green"></v-progress-circular>
      &nbsp;&nbsp;Gerando relatório...Aguarde alguns instantes por favor.
    </v-alert>
    <v-divider></v-divider>
  </div>
</template>

<script>
import FechamentoMesService from "@/common/services/http/fechamentoMes.service";
import KTCodePreview from "@/views/partials/content/CodePreview.vue";
import ApiService from "@/common/services/http/api.service";

export default {
  data: () => ({
    filtro: {
      clienteID: null,
    },
    loading: false,
    carregandoClientes: false,
    clientes: [],
  }),
  components: {
    KTCodePreview,
  },
  methods: {
    async gerar() {
      this.loading = true;
      let params = null;

      if (this.filtro.clienteID) {
        params = { clienteID: this.filtro.clienteID };
      }
      const result = await FechamentoMesService.get(params);
      if (result.success) {
        const link = document.createElement("a");
        link.href = result.data;
        link.download = "relatorio_fechamento";
        link.style.display = "none";

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }

      this.loading = false;
    },

    async listarClientes() {
      this.carregandoClientes = true;
      const result = await ApiService.get("cliente");

      if (result.data.success)
        this.clientes = result.data.data.sort((a, b) =>
          a.nome.localeCompare(b.nome)
        );
      this.carregandoClientes = false;
    },
  },
  async mounted() {
    this.usuario = JSON.parse(window.localStorage.getItem("usuario")).usuario;

    if (!this.usuario.administrador) {
      this.$router.push({ name: "index" });
    }

    this.listarClientes();
  },
};
</script>
